import { render, staticRenderFns } from "./FormularioMotivo.vue?vue&type=template&id=33fd8626"
import script from "./FormularioMotivo.vue?vue&type=script&lang=js"
export * from "./FormularioMotivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports